import React, { useContext, useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { ImpersonationContext } from '../../contexts/ImpersonationContext';

const formatRemaining = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

const ImpersonationBanner: React.FC = () => {
  const { session, endSession } = useContext(ImpersonationContext);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!session) return undefined;
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [session]);

  if (!session) return null;

  const remainingMs = new Date(session.expiresAt).getTime() - now;

  return (
    <Alert
      severity="error"
      variant="filled"
      sx={{ borderRadius: 0, justifyContent: 'center', position: 'sticky', top: 0, zIndex: 1300 }}
      action={
        <Button color="inherit" size="small" onClick={() => endSession()}>
          End Session
        </Button>
      }
    >
      Impersonating {session.targetTenantName} as {session.targetUserName} — READ ONLY | {formatRemaining(remainingMs)}
    </Alert>
  );
};

export default ImpersonationBanner;
